// Single source of truth for Malaysia SST on commercial solar.
//
// SST = 6% service tax on the 20% "service" portion of the price (≈1.2% effective).
// ONE canonical round-off is used by EVERY quotation + commission path (create-sales
// card, CSC Combined / Multi-Meter tabs, CSC proposal, CSC WhatsApp, the standalone
// Form Generator, and the backend claim-total fallback):
//
//   portion = round2(base × 20%)   // 2 decimals — the "PRICE" line on the quotation
//   sst     = round2(portion × 6%) // 2 decimals — SST is exactly 6% of that shown line
//
// SST is kept to 2 decimals (NOT whole ringgit) so the exact tax shows on the
// commercial quotation / CSC / commercial create-sales — the sales card, CSC tabs,
// proposal, WhatsApp and the generated PDF still all agree because they share this one
// helper, and the SST equals 6% of the displayed 20%-portion figure. Non-commercial
// callers must simply not apply SST. (user 2026-07-28; 2-dp per user 2026-08-04)
export const SST_RATE = 0.06;
export const SST_PORTION = 0.20;

// Round to 2 decimals (sen precision), half-away-from-zero.
const round2 = (n) => Math.round(((Number(n) || 0) + Number.EPSILON) * 100) / 100;

// The taxable 20% portion, 2 decimals (the "PRICE" line on the commercial quotation).
export const sstPortion = (base) => round2((Number(base) || 0) * SST_PORTION);

// SST amount, 2 decimals. `base` = the price being split (system final + add-on, or
// the selected-method price). 0 in → 0 out.
export const sstOn = (base) => round2(sstPortion(base) * SST_RATE);

// base + SST — the SST-inclusive grand total the customer pays.
export const withSst = (base) => (Number(base) || 0) + sstOn(base);

// "Deduct SST" discount — the discount D applied to `base` such that, once SST
// recomputes on the discounted base, the SST-inclusive grand total lands back
// exactly on the ORIGINAL pre-SST `base` (the customer effectively pays no SST):
//
//   (base − D) · (1 + p·r) = base   ⇒   D = base·p·r / (1 + p·r) = sstOn(base) / (1 + p·r)
//
// where p·r = SST_PORTION × SST_RATE = 0.012 (the ≈1.2% effective rate). We divide
// the exact 2-dp sstOn(base) by 1.012 so the offset matches the shown SST to the sen.
// This is a FULL absorb; callers may pass a smaller amount for a PARTIAL SST discount.
// It is an ordinary discount → it reduces FinalPrice and therefore flows through the
// existing commission path (Astern + Agent bear it). (user 2026-08-10)
export const sstAbsorb = (base) => round2(sstOn(base) / (1 + SST_PORTION * SST_RATE));
